import {
  PacketModule,
  createPacketServices
} from "./chunk-DI7F6ITA.mjs";
import "./chunk-YAJQ3QCK.mjs";
export {
  PacketModule,
  createPacketServices
};
